'use client';
import React, { useState } from 'react';
import ProfileTab from './ProfileTab';
import ProjectTab from './ProjectTab';
import Icon from '@/components/ui/AppIcon';

type SettingsTab = 'profile' | 'project';

export default function SettingsContent() {
  const [activeTab, setActiveTab] = useState<SettingsTab>('profile');

  const tabs: { id: SettingsTab; label: string; icon: string }[] = [
    { id: 'profile', label: 'Profile', icon: 'UserCircleIcon' },
    { id: 'project', label: 'Project', icon: 'FolderOpenIcon' },
  ];

  return (
    <div className="px-4 lg:px-8 xl:px-10 2xl:px-16 py-6 max-w-screen-2xl mx-auto">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-foreground">Settings</h1>
        <p className="text-sm text-muted-foreground mt-0.5">Manage your profile and project configuration</p>
      </div>

      <div className="flex flex-col lg:flex-row gap-6">
        {/* Sidebar nav */}
        <div className="lg:w-52 flex-shrink-0">
          <nav className="flex lg:flex-col gap-1">
            {tabs.map((tab) => (
              <button
                key={`settings-tab-${tab.id}`}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-150 text-left w-full ${
                  activeTab === tab.id
                    ? 'bg-primary/15 text-primary' :'text-muted-foreground hover:bg-secondary hover:text-foreground'
                }`}
              >
                <Icon name={tab.icon as any} size={18} />
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        {/* Tab content */}
        <div className="flex-1 min-w-0">
          <div className="fade-in">
            {activeTab === 'profile' ? <ProfileTab /> : <ProjectTab />}
          </div>
        </div>
      </div>
    </div>
  );
}